import React from 'react';
import clsx from 'clsx';
import Depot from '../../_shared/depot';
import * as styles from './style.module.css';
import SegmentWrapper from './SegmentedButtonWrapper';
const prefix = 'segmentedButton';
export const SegmentedButtonTypes = [
    'standard',
    'filter',
    'supported',
];
const SegmentedButtonWithoutRef = ({ type, segments, allowMultipleSelection = false, supportLabelAbove = false, testId = `${prefix}-container`, className, ...commonProps }) => {
    var _a, _b;
    const rootClasses = clsx(className, styles.root, styles[type]);
    const activeDescendantId = (_b = (_a = segments === null || segments === void 0 ? void 0 : segments.filter((segment) => segment.checked)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id;
    const listboxAriaAttributes = allowMultipleSelection
        ? {
            'aria-activedescendant': activeDescendantId,
            'aria-label': commonProps['aria-label'],
        }
        : {
            'aria-label': commonProps['aria-label'],
        };
    return Depot.createElement('fieldset', {
        className: rootClasses,
        testId,
        ...commonProps,
    }, React.createElement("div", { role: "listbox", className: styles.controls, ...listboxAriaAttributes }, type === 'supported'
        ? segments === null || segments === void 0 ? void 0 : segments.map(({ supportLabel, ...segment }, index) => (React.createElement(SegmentWrapper, { ...segment, supportLabel: supportLabel, key: index, segmentedButtonType: type, allowMultipleSelection: allowMultipleSelection, supportLabelAbove: supportLabelAbove, testId: `${prefix}-segment` })))
        : segments === null || segments === void 0 ? void 0 : segments.map((segment, index) => (React.createElement(SegmentWrapper, { ...segment, key: index, segmentedButtonType: type, allowMultipleSelection: allowMultipleSelection, supportLabelAbove: supportLabelAbove, testId: `${prefix}-segment` })))));
};
const SegmentedButton = Depot.withRef(SegmentedButtonWithoutRef);
SegmentedButton.displayName = 'SegmentedButton';
export default SegmentedButton;
//# sourceMappingURL=index.js.map